window.chilid = window.chilid || {};

chilid.VARS = {
  HOME_CAROUSEL: $('.js-home-carousel'),
  HOME_CAROUSEL_LEFT: $('.js-home-carousel-left'),
  MOBILE_HOME_CAROUSEL: $('.js-mobile-home-carousel'),
  SINGLE_PRODUCT_CAROUSEL: $('.js-single-product-carousel'),
  GRID_SELECTOR_2: $('.js-grid-selector-2'),
  GRID_SELECTOR_4: $('.js-grid-selector-4'),
  GRID: $('.js-grid'),
  BACK_TO_TOP: $('.js-back-to-top'),
  ADD_TO_COLLECTION_BUTTON: $('.js-toggle-collection'),
  ADD_TO_PROLISTING_BUTTON: $('.js-toggle-collection'),
  SWATCH_FORM: $('.js-swatch-form'),
  SWATCH_INPUTS: $('.circular-swatch__input, [type=checkbox]'),
  PRINT_BTN: $('.js-print-btn'),
  MODEL_OPTION: $('.js-model__option'),
  MODEL_OPTION_DEACTIVATED: $('.js-model__image--no-action, .js-model__desc--no-action'),
  HOUZZ_HREF: $('.houzz-share-button')
}

document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    callback: function() {
      console.log('dsdfas');
      const $addToCollectionButtons = $('.js-toggle-collection').not('.on-click-listener-added');
      if ($addToCollectionButtons.length) {
        $addToCollectionButtons.each(function () {
          chilid.toggleCollection($(this));
        });
      }
      chilid.gridUpdate(chilid.VARS.GRID_SELECTOR_2, chilid.VARS.GRID_SELECTOR_4);
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  	var timerId = setInterval(function(){
    var attr = $('div.spf-col-xl-3').attr('data-page'); 
      //console.log(attr);
        const $addToCollectionButtons = $('.js-toggle-collection').not('.on-click-listener-added');
        if ($addToCollectionButtons.length) {
          $addToCollectionButtons.each(function () {
            chilid.toggleproductlist($(this));
          });
        }
		if(attr === '1'){
       		clearInterval(timerId);
        } 
  }, 3000);
}); 

chilid.init = function() {

  if(chilid.VARS.HOME_CAROUSEL.length) {
    chilid.initHomeCarousel(chilid.VARS.HOME_CAROUSEL);
  }

  if(chilid.VARS.HOME_CAROUSEL_LEFT.length) {
    chilid.initHomeCarouselLeft(chilid.VARS.HOME_CAROUSEL_LEFT);
  }

  if(chilid.VARS.MOBILE_HOME_CAROUSEL.length) {
    chilid.initMobileHomeCarousel(chilid.VARS.MOBILE_HOME_CAROUSEL);
  }

  if(chilid.VARS.SINGLE_PRODUCT_CAROUSEL.length) {
    chilid.initSingleProductCarousel(chilid.VARS.SINGLE_PRODUCT_CAROUSEL);
  }

  if (chilid.VARS.ADD_TO_COLLECTION_BUTTON.length) {
    chilid.VARS.ADD_TO_COLLECTION_BUTTON.each(function () {
      chilid.toggleCollection($(this));
    });
  }
  
  if (chilid.VARS.ADD_TO_PROLISTING_BUTTON.length) {
    //console.log(chilid.VARS.ADD_TO_PROLISTING_BUTTON.length);
    //setInterval(function(){
      chilid.VARS.ADD_TO_PROLISTING_BUTTON.each(function () {
        chilid.toggleproductlist($(this));
      });
    //}, 5000);
  }

  if (chilid.VARS.PRINT_BTN.length) {
    chilid.printBtnHandle(chilid.VARS.PRINT_BTN);
  }

  if (chilid.VARS.SWATCH_INPUTS.length) {
    chilid.togglePrintMode(chilid.VARS.SWATCH_INPUTS);
  }

  if (chilid.VARS.MODEL_OPTION.length) {
    chilid.activateHoverClass(chilid.VARS.MODEL_OPTION, chilid.VARS.MODEL_OPTION_DEACTIVATED);
  }

  if (chilid.VARS.HOUZZ_HREF.length) {
    chilid.convertHref(chilid.VARS.HOUZZ_HREF);
  }

  chilid.gridSelector(chilid.VARS.GRID_SELECTOR_2, chilid.VARS.GRID_SELECTOR_4);
  chilid.backToTop(chilid.VARS.BACK_TO_TOP);
  chilid.hideHover();
  chilid.showMore();
  chilid.addLinkTarget();

  var url = window.location.href;
  if (url.indexOf('/products') !== -1) {
    chilid.showRandomProductsDesktop();
  }

  chilid.loadMore();
}

chilid.convertHref = function($Houzz) {
  var $HouzzHref = $Houzz.attr('href');
  var linkParts = $HouzzHref.split('?v');
  var encodedParameter = encodeURIComponent(linkParts[1])
  linkParts[1] = encodedParameter;
  var hrefAfterEncoding = linkParts.join("?v");

  $Houzz.attr("href", hrefAfterEncoding);
}

chilid.activateHoverClass = function($ModelOptions, $ModelOptionsUnactive) {
  $ModelOptions.hover(function() {
   $ModelOptionsUnactive.removeClass('js-model__image--no-action js-model__desc--no-action')
  });
}

chilid.togglePrintMode = function($printSwitches) {
  $printSwitches.each(function(index, value) {
    $(this).click(function () {
      $printSwitches.each(function (index, value){

        if (value.type === 'radio') {
          $(value).removeClass('print');
        }
      })

      if (this.type === 'radio') {
        $(this).addClass('print');
        $(this).attr('checked', 'checked');
      }

      else if (this.checked || this.type === 'checkbox') {
        $(this).toggleClass('print');
      }
    })
  });
}

chilid.initHomeCarousel = function($homeCarousel) {
  $homeCarousel.slick({
    dots: true,
    arrows: false,
    asNavFor: '.js-home-carousel-left',
    autoplay: true,
    autoplaySpeed: 2000
  });
}

chilid.initHomeCarouselLeft = function($homeCarouselLeft) {
  $homeCarouselLeft.slick({
    dots: false,
    arrows: false,
    asNavFor: '.js-home-carousel'
  });
}

chilid.initMobileHomeCarousel = function($mobileHomeCarousel) {
  $mobileHomeCarousel.slick({
    dots: true,
    arrows: false
  });
}

chilid.initSingleProductCarousel = function($singleProductCarousel) {
  $singleProductCarousel.slick({
    dots: true,
    arrows: true
  });
}

chilid.printBtnHandle = function ($printBtn) {
  $printBtn.on('click', function(e) {
    e.preventDefault();
    window.print();
  });
}

chilid.handleGridSelector2Click = function($grid, $gridSelector2, $gridSelector4) {
  $grid.addClass('large--one-half');
  $grid.removeClass('large--one-quarter');
  $gridSelector2.addClass('products__options__number--selected');
  $gridSelector4.removeClass('products__options__number--selected');
};

chilid.handleGridSelector4Click = function($grid, $gridSelector2, $gridSelector4) {
  $grid.addClass('large--one-quarter');
  $grid.removeClass('large--one-half');
  $gridSelector4.addClass('products__options__number--selected');
  $gridSelector2.removeClass('products__options__number--selected');
};

chilid.gridSelector = function($gridSelector2, $gridSelector4) {
  $gridSelector2.click(function() {
    chilid.handleGridSelector2Click($('.js-grid'), $gridSelector2, $gridSelector4);
  });
  $gridSelector4.click(function() {
    chilid.handleGridSelector4Click($('.js-grid'), $gridSelector2, $gridSelector4);
  });
};

chilid.gridUpdate = function($gridSelector2, $gridSelector4) {
  var $grid = $('.js-grid');
  if ($gridSelector2.hasClass('products__options__number--selected')) {
    chilid.handleGridSelector2Click($grid, $gridSelector2, $gridSelector4);
  }
  if ($gridSelector4.hasClass('products__options__number--selected')) {
    chilid.handleGridSelector4Click($grid, $gridSelector2, $gridSelector4);
  }
};

chilid.backToTop = function($btn) {
  $btn.click(function() {
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  });

  $(window).scroll(function() {
    var height = $(window).scrollTop();
    if (height  >= 300) {
      $btn.addClass('js-show');
    }
    else {
      $btn.removeClass('js-show');
    }
  });
}

chilid.addLinkTarget = function(){
  jQuery('a[href^="http://topbrasslighting.com"]').not('a[href^="'+$(location).attr('hostname')+'"]').attr('target', '_blank');
}

chilid.loadMore = function() {
  var productsLimit = 12;
  var productsVisible = productsLimit;
  var $items = $('.js-products > .js-product');
  var itemsLength = $items.length;

  $items.hide();

  for(var i = 0; i < productsLimit; i++) {
    $items.eq(i).show();
  }

  if (productsVisible >= itemsLength) {
    $('.js-load-more').hide();
  }

  $('.js-load-more').click(function() {
      for(var i = productsVisible; i < productsVisible + productsLimit; i++) {
          $items.eq(i).show();
      }

      if (productsVisible < itemsLength) {
          productsVisible = productsVisible + productsLimit;
      }

      if (productsVisible >= itemsLength) {
          $('.js-load-more').hide();
      }
  });

}

chilid.hideHover = function() {
  $('.js-styles-box').hover(function() {
    $('.js-styles-box-visible').removeClass('styles__info--visible');
  });
}

chilid.showMore = function() {
  $('.js-show-more').click(function(event) {
    if ($(event.target).attr('class') === 'product-single__title') {
      $(this).toggleClass('is-full');
    }
  });
}

chilid.showRandomProductsDesktop = function() {
    var $alsoLikeProductsDesktop = $('.js-also-like-desktop').find();
    var $alsoLikeProductsMobile = $('.js-also-like-mobile').find();
    var $alsoLikeProductsLength = $('.js-also-like-desktop').length - 1;

    var numbersArray = [];
    for (var i = 0; i < $alsoLikeProductsLength+1; i++) {
      numbersArray.push(i);
    }

    var randomNumbers = [];
    for (numbersArray, i = numbersArray.length; i--; ) {
        var random = numbersArray.splice(Math.floor(Math.random() * (i + 1)), 1)[0];
        randomNumbers.push(random);
    }

    randomNumbers.splice(3, $alsoLikeProductsLength);

    var randomNumbersMobile = randomNumbers.slice();
    randomNumbersMobile.splice(-1,1);

    $alsoLikeProductsDesktop.prevObject.each(function (elem) {
      if ($.inArray(elem, randomNumbers) === -1) {
        $alsoLikeProductsDesktop.prevObject[elem].remove();
      }
    });

    $alsoLikeProductsMobile.prevObject.each(function (elem) {
      if ($.inArray(elem, randomNumbersMobile) === -1) {
        $alsoLikeProductsMobile.prevObject[elem].remove();
      }
    });
}

/* My Collection */
var getProductsInCollection = function () {
  return $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json'
  });
}

chilid.toggleCollection = function ($button) {
  var id = $button.data('id');
  var productIds = [];
  
  getProductsInCollection()
    .done(function(data) {
      productIds = data.items.map(function(el) { return el.variant_id });

      if (productIds.indexOf(id) > -1) {
        $button.addClass('like-icon--unlike');
      }
    });
  $button.on('click', function(e) {
    
    e.preventDefault();
    var $this = $(this);

    getProductsInCollection()
      .done(function(data) {
        productIds = data.items.map(function(el) { return el.variant_id });

        if (productIds.indexOf(id) === -1) {
          $.post('/cart/add.js', {
            id: id,
            quantity: 1
          });
        } else {
          $.post('/cart/change.js', {
            id: id,
            quantity: 0
          });
        }
        $this.toggleClass('like-icon--unlike');
      });
  });

  $button.addClass('on-click-listener-added');
}

//setInterval(function(){
chilid.toggleproductlist = function ($button) {
  var id = $button.data('id');
  var productIds = [];
  getProductsInCollection()
    .done(function(data) {
      productIds = data.items.map(function(el) { return el.variant_id });

      if (productIds.indexOf(id) > -1) {
        $button.addClass('like-icon--unlike');
      }
    });

  $button.on('click', function(e) {
    e.preventDefault();
    var $this = $(this);

    getProductsInCollection()
      .done(function(data) {
        productIds = data.items.map(function(el) { return el.variant_id });

        if (productIds.indexOf(id) === -1) {
          $.post('/cart/add.js', {
            id: id,
            quantity: 1
          });
        } else {
          $.post('/cart/change.js', {
            id: id,
            quantity: 0
          });
        }
        $this.toggleClass('like-icon--unlike');
      });
  });

  $button.addClass('on-click-listener-added');
}
//}, 5000);

/* Initialization */
$(chilid.init);
